module.exports = __webpack_public_path__ + "static/media/unicorn.c5c72ff1.svg";